import React, { useEffect, useState } from 'react';
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

export default function ArticleCard() {
    const [articles, setArticles] = useState([]);
    
    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await pb.collection('Articles').getFullList();
                setArticles(response);
            } catch (error) {
                console.error("Error fetching articles:", error);
            }
        };
        fetchArticles();
    }, []);

    if (!articles.length) {
        return <div>No articles available</div>;
    }

    return (
        <div>
            {articles.map((article) => (
                <div key={article.id} className="article-card border rounded shadow-sm p-4 mb-4">
                    <div 
                        className="article-content"
                        dangerouslySetInnerHTML={{ __html: article.conent }}
                    />
                </div>
            ))}
        </div>
    );
}